<template>
    <div class="give-wrap">
        <!--  次数赠送弹框 -->
        <a-modal
            :visible="visibleGive"
            title='次数赠送'
            @cancel="closeModalGive"
            @ok="handleCreateGive"
            :width="700"
            :confirmLoading="confirmLoading"
            >
            <div>
                <member-card :ticketData="ticketData" :showOwner="false"></member-card>
            </div>
            <a-form :form="form">
                <a-form-item label="增加次数" :labelCol="{span: 4}" :wrapperCol="{span: 18}">
                    <a-input-number
                        style="width:100%"
                        placeholder="请输入正整数"
                        :min="1"
                        :precision="0"
                        v-decorator="['giveNum',{rules: [{required: true, message: '请输入次数'}]}]"
                    />
                </a-form-item>
                <remark :labelSpan="4" :wrapperSpan="18" operateCode="NumGive" />
                <shop :isOrigal="true" :labelSpan="6" :wrapperSpan="18"/>
            </a-form>
        </a-modal>
    </div>
</template>

<script>

    /**
     * 次数赠送弹框组件
     * @prop {Object} ticketData 基础卡对象
     * @prop {Boolean} visibleGive 控制弹窗是否显示
     *
     * @func closeModalGive 通知父组件关闭弹窗
     *
     */
    import memberCard from "@/components/modules/order/member-card.component";
    import remark from '@/components/modules/platform/remark.component';
    import shop from '@/components/modules/platform/shop.component';

    export default {
        name: "member-order-give",
        zh: "次数赠送弹框组件",
        data() {
            return {
                confirmLoading: false,
            };
        },
        props: {
            ticketData: {type: Object},
            visibleGive: {type: Boolean},
        },
        components: {
            memberCard,
            remark,
            shop
        },
        methods: {
            handleCreateGive() {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        const shopItem = JSON.parse(values.shop);
                        this.confirmLoading = true
                        this.$api.order.increase({
                            body: {
                                userTicketNo: this.ticketData.userTicketNo,
                                userId: this.ticketData.userId,
                                phone: this.ticketData.phone,
                                giveNum: values.giveNum,
                                remark: values.remark,
                                remarkCategoryCode: values.remarkCategoryCode,
                                remarkCategoryName: values.remarkCategoryName,
                                shopId: shopItem.id,
                                shopName: shopItem.name,
                            }
                        }).then(res => {
                            this.confirmLoading = false;
                            this.$message.success('操作成功');
                            this.closeModalGive();
                        }).catch(err => {
                            this.confirmLoading = false;
                        });
                    }
                })
            },
            closeModalGive() {
                this.confirmLoading = false;
                this.$emit('changeVisibleGive', false);
                this.form.resetFields();
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this)
        },
        created() {},
        updated() {},
        mounted() {},
        computed: {},
        watch: {
            'ticketData'(val) {
                this.ticketData = val
            }
        }
    };
</script>

<style lang="scss">

</style>
